module.exports = "./img/desktop_logo.8e1a90d.png";